import { useState } from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SpaceReclaimed from "@/components/SpaceReclaimed";
import AIEstimate from "@/components/AIEstimate";
import HowItWorks from "@/components/HowItWorks";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Transformations from "@/components/Transformations";
import Trust from "@/components/Trust";
import Reviews from "@/components/Reviews";
import ServiceAreas from "@/components/ServiceAreas";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import EstimateFlow from "@/components/EstimateFlow";
import StickyMobileBar from "@/components/StickyMobileBar";
import Admin from "@/pages/Admin";
import QuotePage from "@/pages/QuotePage";
import PaymentReturn from "@/pages/PaymentReturn";
import ReschedulePage from "@/pages/ReschedulePage";
import CityPage from "@/pages/CityPage";
import ServicePage from "@/pages/ServicePage";
import CostGuidePage from "@/pages/CostGuidePage";

function App() {
  const [flowOpen, setFlowOpen] = useState(false);
  const start = () => setFlowOpen(true);

  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
    return <Admin />;
  }
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/quote/")) {
    return <QuotePage />;
  }
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/reschedule/")) {
    return <ReschedulePage />;
  }
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/payment-return")) {
    return <PaymentReturn />;
  }
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/junk-removal/")) {
    return <CityPage />;
  }
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/services/")) {
    return <ServicePage />;
  }
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/junk-removal-cost")) {
    return <CostGuidePage />;
  }

  return (
    <div className="App grain">
      <Navbar onStart={start} />
      <main>
        <Hero onStart={start} />
        <SpaceReclaimed />
        <AIEstimate onStart={start} />
        <HowItWorks />
        <Services />
        <Pricing onStart={start} />
        <Transformations />
        <Trust />
        <Reviews />
        <ServiceAreas onStart={start} />
        <FAQ />
        <FinalCTA onStart={start} />
      </main>
      <Footer onStart={start} />
      <StickyMobileBar onStart={start} hidden={flowOpen} />
      <EstimateFlow open={flowOpen} onClose={() => setFlowOpen(false)} />
    </div>
  );
}

export default App;
